
import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

const TimeSeriesGraph = ({ fieldsData, selectedField }) => {
  console.log(fieldsData, selectedField)
  const fieldUnits = {
    TankLevel: 'Gallons',
    GrainTotal: 'Lbs', 
    Batches: '#'
  };

  const [seriesData, setSeriesData] = useState({
    series: [
      {
        name: `${selectedField} (${fieldUnits[selectedField]})`,
        data: [],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        background: 'transparent',
        height: 350,
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true,
        },
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
          },
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
      },
      colors: ['#F88945'],
      xaxis: {
        order: {
          ascending: true
        },
        tickPlacement: 'on',
       
        labels: {
          style: {
            colors: '#EAEAEA',
            fontSize: '12px',
          },
          hideOverlappingLabels: true,
          maxHeight: 60,
        },
        title: {
          text: 'Date',
          style: {
            color: '#EAEAEA',
          },
        },
        tickAmount: 10, // Control the number of ticks for readability
      },
      yaxis: {
        title: {
          text: `${selectedField} (${fieldUnits[selectedField]})`,
          style: {
            color: '#EAEAEA',
          },
        },
        labels: {
          style: {
            colors: '#EAEAEA',
          },
        },
      },
      title: {
        
        text: `${selectedField} (${fieldUnits[selectedField]})`,
        style: {
          color: '#EAEAEA',
        },
      },
      tooltip: {
        theme: 'dark',
      },
      dataLabels: {
        style: {
          colors: ['#F3F4F6'],
        },
        offsetY: -10,
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            chart: {
              height: 300,
            },
            xaxis: {
        
              labels: {
                style: {
                  fontSize: '12px',
                },
              },
            },
            yaxis: {
              labels: {
                style: {
                  fontSize: '12px',
                },
              },
            },
          },
        },
      ],
    },
  });

    //may need to use this function to sort the array
  const sortBatches = (data) => {
    return data
    // return data.sort((a, b) => {
    //   const aParts = a.id.split('_');
    //   const bParts = b.id.split('_');
    //   const aNum = parseInt(aParts[aParts.length - 1], 10);
    //   const bNum = parseInt(bParts[bParts.length - 1], 10);
    //   return aNum - bNum;
    // });
  };

  useEffect(() => {
    const sortedData = sortBatches([...fieldsData]);

   // console.log("Sroted data: " + sortedData)
    // const dataSeries = sortedData.map((item) => ({
    //   x: String(item.Date) || "N/A",
    //   y: Number(item[selectedField]) || 0,
    // }));

    const dataSeries = sortedData.map(item => {

      let formattedString = String(item.Date).slice(0, 2) + "/" +  String(item.Date).slice(2, 4) + "/" + String(item.Date).slice(4, 6)
      
      return {
        x: formattedString || "N/A",
        y: Number(item[selectedField]) || 0,
      }
    })

    setSeriesData((prevData) => {
      return {
        ...prevData,
        series: [{name: `${selectedField} (${fieldUnits[selectedField]})`, data: dataSeries }],
        options: {
          ...prevData.options,
          xaxis: {
            ...prevData.options.xaxis,
            categories: dataSeries.map(data => {
                console.log("Data x:" + data.x)
                return data.x
            }),
            tickAmount: Math.min(10, dataSeries.length),
          },
          dataLabels: {
            enabled: true
          },
          yaxis: {
            ...prevData.options.yaxis,
            title: {
              text: `${selectedField} (${fieldUnits[selectedField]})`,
              style: {
                color: '#EAEAEA',
              },
            },
          },
          title: {
            ...prevData.options.title,
            text: `${selectedField} (${fieldUnits[selectedField]})`,
          },
        },
      };
    });
  }, [fieldsData, selectedField]);

  return (
    <div className="w-full h-full">
      <div className="w-full overflow-auto">
        <ReactApexChart options={seriesData.options} series={seriesData.series} type="bar" height={350} />
      </div>
    </div>
  );
};

// String.prototype.removeChar = function () {
//   var tmp = this.split('_'); // convert to an array
//  // extract batch number from batch id
//   return tmp[1]; // reconstruct the string
// }

export default TimeSeriesGraph;
